module.exports = __webpack_public_path__ + "img/larissa-eberhardt.2eb1d67d.jpg";